import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import React, { useState } from "react";

import Pages from "./containers/Pages";

import { ThemeProvider } from "@mui/material";
import { lightTheme, darkTheme } from "./theme";

import { AuthProvider } from "./contexts/Auth/AuthContext";
import { HttpProvider } from "./contexts/HTTP/HttpContext";
import { ImageProvider } from "./contexts/Image/ImageContext";
import { ConfigProvider } from "./contexts/Config/ConfigContext";
import { MobileProvider } from "./contexts/Mobile/MobileContext";
import { ModelProvider } from "./contexts/Model/ModelContext";

import { get, post } from "./utils/api";

function App() {
  const [theme, setTheme] = useState(lightTheme);
  const [authenticated, setAuthenticated] = useState(null);
  const [imageData, setImageData] = useState({ raw: [], processed: [] });
  const [config, setConfig] = useState({});
  const [models, setModels] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // useEffect(() => {
  //   document.body.style.backgroundColor = theme.palette.background.default;
  // });

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider value={{ authenticated, setAuthenticated }}>
        <HttpProvider value={{ get, post }}>
          <ImageProvider value={{ imageData, setImageData }}>
            <ConfigProvider value={{ config, setConfig }}>
              <MobileProvider value={{ isMobile, setIsMobile }}>
                <ModelProvider value={{ models, setModels }}>
                  <Pages />
                </ModelProvider>
              </MobileProvider>
            </ConfigProvider>
          </ImageProvider>
        </HttpProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
